import { useEffect, useRef } from 'react';

/**
 * Provides a value from a previous component render.
 *
 * @param value The value from the current render
 * @returns The value from the previous render.
 */
export default function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
